import React, { useEffect, useRef } from "react";
import Custombutton from "./Custombutton";

const StackingCards = () => {
  const projects = [
    {
      title: (
        <>
          <span className="gradient1">NEBULA</span><br /> <span className="gradient2">LITE</span>
        </>
      ),
      description:
        "Cosmic Routers are the backbone of the network, offering users a convenient and feature-rich solution.",
      src: "./assets/images/router-new.png",
      link: "/#/nebula-lite",
    },
    {
      title: (
        <>
          <span className="gradient1">COSMIC</span><br /> <span className="gradient2">VPN</span>
        </>
      ),
      description:
        "Experience secure, decentralized and fast internet with our dVPN app. Currently available for Windows, macOS, IOS & Android.",
      src: "./assets/images/vpn-app.png",
      link: "/#/DVPN",
    },
    {
      title: (
        <>
          <span className="gradient1">COSMIC</span> <br /><span className="gradient2">NODES</span>
        </>
      ),
      description:
        "Cosmic Nodes form the backbone of the Cosmic Network, ensuring reliability and decentralization. While some nodes are hosted and managed by Cosmic for optimal performance.",
      src: "./assets/images/node-new.png",
      link: "/#/nodes",
    },
  ];

  const stackCardsRef = useRef(null);

  useEffect(() => {
    if (!("IntersectionObserver" in window)) return;

    const items = stackCardsRef.current.querySelectorAll(
      ".js-stack-cards__item"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.5 }
    );

    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <ul
      className="stack-cards js-stack-cards"
      ref={stackCardsRef}
      style={{ position: "relative" }}
    >
      {projects.map((project, index) => (
        <li
          key={index}
          className={`stack-cards__item sg0-bg-light card-custom sg0-radius-lg sg0-inner-glow sg0-shadow-md js-stack-cards__item card-${index + 1}`}
        >
          <div className="sg0-flex-center">
            <div className="row align-items-start align-items-md-center h-100">
              <div className="col-lg-6 p-5 p-lg-5 order-lg-1 order-2">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="button-group">
                <div className="d-flex buttons align-items-center gap-3">
                  {/* {index === 0 && (
                    <Custombutton label={"Buy Now"} className={"btn-bg px-5"} />
                  )} */}
                  <a href={project.link} target="_blank" rel="noopener noreferrer">
                    <Custombutton
                      label={"Learn More"}
                      className={"btn-outline gradient-text gradient-outline px-5 py-3 learn-more"}
                    />
                  </a>
                </div>
                {index === 1 && (
                  <div className="additional-buttons">
                    <Custombutton label={" "} className={"btn-outline px-4 windows"} />
                    <Custombutton label={" "} className={"btn-outline px-4 andriod"} />
                    <Custombutton label={" "} className={"btn-outline px-4 apple"} />
                    <Custombutton label={" "} className={"btn-outline px-4 mac"} />
                  </div>
                )}
              </div>
              </div>
              <div className="col-lg-6 order-lg-2 order-1">
                <img className="w-100" src={project.src} alt={project.title} />
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default StackingCards;